import * as React from 'react';
import { useTheme } from '../theme';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

interface Props {
	hideText?: boolean;
	className?: string;
	loaderClassName?: string;
	spinnerClassName?: string;
}
const Loader: React.FunctionComponent<Props> = props => {
	const css = useTheme().Loader,
		{ t } = useTranslation('Loader');

	return (
		<div className={cn(css.loader__content, props.className)} data-test-id="loader">
			<div className={cn(css.loader, props.loaderClassName)}>
				<div className={cn(css.loader_spinner, props.spinnerClassName)} />
			</div>{' '}
			{!props.hideText && `${t('loading')}...`}
		</div>
	);
};

export default Loader;
